import type { ResourcePoolView } from "./game-view-model";

const RESOURCE_LABELS: readonly [keyof ResourcePoolView, string][] = [
  ["food", "Food"],
  ["production", "Production"],
  ["trade", "Trade"],
  ["science", "Science"],
  ["culture", "Culture"],
];

export function formatResources(resources: ResourcePoolView): string {
  const values = RESOURCE_LABELS.flatMap(([key, label]) =>
    resources[key] === 0 ? [] : [`${resources[key]} ${label}`],
  );
  return values.length === 0 ? "None" : values.join(" / ");
}
